export default __webpack_public_path__ + "static/media/mars29.32943c42.gif";